/**
 * `useResolvedTeamId` — resolve `teamId` from either the `/teams/:teamId/*`
 * or `/cycles/:cycleId/*` URL family.
 *
 * Extracted from `<TeamAuditTickerSection/>` (#196) so that
 * `<PersistentRightPanel/>` can wrap individual sections in
 * `<ComponentGate teamId={...}>` at the panel level (#193). Both the
 * panel wrapper and the section itself read the same resolved id; the
 * underlying `useCycle` query shares cache, so the duplicate hook call
 * does not double-fetch.
 *
 * Returns `{ teamId: undefined, resolving: false }` when neither URL
 * shape is present (e.g. `/settings/profile`) — callers should self-hide
 * in that case rather than attempting a fetch.
 */
import { useParams } from "react-router-dom";

import { useCycle } from "../api/useCycle";

export function useResolvedTeamId(): { teamId: string | undefined; resolving: boolean } {
  const { teamId, cycleId } = useParams<{ teamId?: string; cycleId?: string }>();
  const cycleQuery = useCycle(cycleId);

  if (teamId) {
    return { teamId, resolving: false };
  }
  if (!cycleId) {
    return { teamId: undefined, resolving: false };
  }
  return {
    teamId: cycleQuery.data?.team_id,
    resolving: cycleQuery.isLoading,
  };
}
